/**
 * 模型提供器
 * 从 agents 模块迁移到 utils 模块，提供独立的模型创建功能
 */

import { ChatOpenAI } from "@langchain/openai";
import { ChatAnthropic } from "@langchain/anthropic";
import { ChatGoogleGenerativeAI } from "@langchain/google-genai";
import { BaseChatModel } from "@langchain/core/language_models/chat_models";
import { getProxyAgent } from "@/lib/utils/httpAgent";

export interface ModelState {
  model?: string;
  [key: string]: any;
}

/**
 * 根据状态配置获取模型实例
 * @param state - 包含模型配置的状态对象
 * @returns BaseChatModel 实例
 */
export function getModel(state: ModelState): BaseChatModel {
  const stateModel = state.model;
  // eslint-disable-next-line no-process-env
  const model = process.env.MODEL || stateModel;

  console.log(`Using model: ${model}`);

  if (model === "openai") {
    const openaiApiKey = process.env.OPENAI_API_KEY;
    return new ChatOpenAI({
      temperature: 1,
      openAIApiKey: openaiApiKey,
      model: "gpt-4o-mini",
      reasoning: {
        effort: 'minimal',
      },
      configuration: {
        baseURL: process.env.OPENAI_BASE_URL,
      },
    });
  }
  
  if (model === "anthropic") {
    return new ChatAnthropic({
      temperature: 0,
      modelName: "claude-3-5-sonnet-20240620",
    });
  }
  
  if (model === "google_genai") {
    return new ChatGoogleGenerativeAI({
      temperature: 0,
      model: "gemini-1.5-pro",
      // eslint-disable-next-line no-process-env
      apiKey: process.env.GOOGLE_API_KEY || undefined,
    });
  }

  throw new Error("Invalid model specified");
}

/**
 * 获取 OpenAI 模型实例
 * @param modelName - OpenAI 模型名称 (e.g., "gpt-4", "gpt-3.5-turbo", "gpt-5-mini")
 * @returns ChatOpenAI 实例
 */
export function getOpenaiModel(modelName: string): ChatOpenAI {
  const openaiApiKey = process.env.OPENAI_API_KEY;

  if (!openaiApiKey) {
    throw new Error("OPENAI_API_KEY environment variable is not set");
  }

  return new ChatOpenAI({
    temperature: 1,
    openAIApiKey: openaiApiKey,
    model: modelName,
    ...(modelName.startsWith("gpt-5") && {
      reasoning: {
        effort: 'minimal',
      }
    }),
    configuration: {
      baseURL: process.env.OPENAI_BASE_URL,
    },
  });
}